import React, { useState } from "react";
import ImageModal from "./ImageModal";
import { variantURL, fallbackToOriginal } from "../utils/imageVariant";
import LocationNotVerifiedBadge from "./LocationNotVerifiedBadge";

// Just above the name bar, centred, so it clears the table number (top left).
const UNVERIFIED_BADGE_POSITION = "absolute bottom-6 left-1/2 -translate-x-1/2 max-w-full truncate";

const CardTable = ({ table, sitter, mover, activeSession, groupCount, onRemoveFromQueue }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  const handleShowImage = (user) => {
    if (!user) return;
    setSelectedUser(user);
    setShowModal(true);
  };

  const isMissingPartner = sitter?.name == null || mover?.name == null;
  const isOnline = (user) => {
    const hasUserLeft = user?.hasLeft;
    if (hasUserLeft) {
      return "line-through text-white opacity-80";
    }
    return "";
  };
  return (
    <>
      <div
        className={`gap-2.5 p-2.5 border border-gray-300 dark:border-gray-600 text-center rounded-md flex h-52 place-content-center bg-primary ${isMissingPartner ? "!bg-[#b5b7bb]" : ""
          }`}
      >
        <div
          className="font-medium text-center text-nowrap w-full overflow-hidden relative min-h-16 rounded-md"
          onClick={() => handleShowImage(sitter)}
        >
          {sitter?.photoURL && (
            <img
              src={variantURL(sitter.photoURL, 512)}
              onError={fallbackToOriginal(sitter.photoURL)}
              alt="profile"
              className="absolute inset-0 w-full h-full object-cover rounded"
            />
          )}
          <span className={`absolute bottom-0 left-0 bg-black/20 w-full justify-center text-white font-medium truncate  ${isOnline(sitter)}`}>
            {sitter?.name?.split(' ')[0] || "\u00A0"}
          </span>
          <LocationNotVerifiedBadge entry={sitter} className={UNVERIFIED_BADGE_POSITION} />
          <span className={`absolute top-0 left-0 text-white font-bold bg-black/30  px-1 py-0.5 ${isOnline(sitter)} ${groupCount == 1 ? "text-xs" : ""}`}>
            {groupCount === 1 ? (sitter?.badgeNumber || "-") : (sitter?.table || "-")}
          </span>
        </div>
        <div
          className="font-medium text-center text-nowrap w-full overflow-hidden rounded-md relative min-h-16"
          onClick={() => handleShowImage(mover)}
        >
          {mover?.photoURL && (
            <img
              src={variantURL(mover.photoURL, 512)}
              onError={fallbackToOriginal(mover.photoURL)}
              alt="profile"
              className="absolute inset-0 w-full h-full object-cover rounded"
            />
          )}
          <span className={`absolute bottom-0 left-0 bg-black/20 w-full justify-center text-white font-medium truncate  ${isOnline(mover)}`}>
            {mover?.name?.split(' ')[0] || "\u00A0"}
          </span>
          <LocationNotVerifiedBadge entry={mover} className={UNVERIFIED_BADGE_POSITION} />
          {groupCount === 1 && (
            <span className={`absolute top-0 left-0 text-white font-bold bg-black/30  px-1 py-0.5 text-xs ${isOnline(mover)}`}>
              {mover?.badgeNumber || "-"}
            </span>
          )}
        </div>
      </div>
      {showModal && (
        <ImageModal
          selectedUser={selectedUser}
          setOpen={setShowModal}
          onRemoveFromQueue={onRemoveFromQueue}
        />
      )}
    </>
  );
};

export default CardTable;

